import * as device from '@/utilities/deviceUtils.js'

export default {
  data: function () {
    // iOS fallback
    const portraitQuery = window.matchMedia('(orientation: portrait)')

    // prettier-ignore
    const deviceOrientation = window.screen.orientation
      ? window.screen.orientation.type.startsWith('portrait')
        ? 'portrait'
        : 'landscape'
      : portraitQuery.matches
        ? 'portrait'
        : 'landscape'

    // console.debug(`[mobileMixin]: Initial device orientation: ${deviceOrientation}`)

    return {
      mobileMixin_portraitQuery: portraitQuery,
      mobileMixin_deviceOrientation: deviceOrientation,
      mobileMixin_height: 0,
      mobileMixin_width: 0
    }
  },

  computed: {
    /* reactive */

    mobileMixin_isMobile() {
      return this.$vuetify.breakpoint.mobile
    },

    mobileMixin_isViewportSmall() {
      // < 960px
      return this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm'
    },

    mobileMixin_isViewportMedium() {
      // 960px - 1264px
      return this.$vuetify.breakpoint.mdAndUp
    },

    mobileMixin_isViewportLarge() {
      // > 1264px
      return this.$vuetify.breakpoint.lgAndUp
    },

    mobileMixin_isLandscape() {
      return this.mobileMixin_width >= this.mobileMixin_height
    },

    mobileMixin_isPortrait() {
      return this.mobileMixin_width < this.mobileMixin_height
    },

    mobileMixin_isReallyLandscape() {
      return this.mobileMixin_isReallyMobile
        ? this.mobileMixin_deviceOrientation === 'landscape'
        : this.mobileMixin_isLandscape
    },

    mobileMixin_isReallyPortrait() {
      return this.mobileMixin_isReallyMobile
        ? this.mobileMixin_deviceOrientation === 'portrait'
        : this.mobileMixin_isPortrait
    },

    mobileMixin_displayOrientation() {
      return device.getOrientation
    },

    mobileMixin_viewportOrientation() {
      return this.mobileMixin_isLandscape ? 'landscape' : 'portrait'
    },

    mobileMixin_orientation() {
      return this.mobileMixin_isReallyMobile
        ? this.mobileMixin_deviceOrientation
        : this.mobileMixin_viewportOrientation
    },

    mobileMixin_optimalAspectRatio() {
      const ratios = {
        xs: 4 / 1,
        sm: 6 / 1,
        md: 8 / 1,
        lg: 8 / 1,
        xl: 10 / 1
      }
      const breakpoint = this.$vuetify.breakpoint.name

      return ratios[breakpoint] || 8 / 1
    },

    /* static */

    mobileMixin_isAndroid() {
      return device.isAndroid()
    },

    mobileMixin_isiOS() {
      return device.isiOS()
    },

    mobileMixin_isMobileOS() {
      return device.isMobileOS()
    },

    mobileMixin_isReallyMobile() {
      return this.mobileMixin_isMobileOS || this.mobileMixin_isiOS
    },

    mobileMixin_isMac() {
      return device.isMac()
    },

    mobileMixin_isiPad() {
      return device.isiPad()
    },

    mobileMixin_isiPhone() {
      return device.isiPhone()
    },

    mobileMixin_iOSVersion() {
      return device.getiOSVersion()
    },

    mobileMixin_browserName() {
      return device.getBrowserName()
    },

    mobileMixin_isSafari() {
      return device.isSafari()
    },

    mobileMixin_isChromeOrEdge() {
      return device.isChromeOrEdge()
    }
  },

  mounted: function () {
    // register change events
    if (window.screen.orientation) {
      window.screen.orientation.addEventListener('change', this.mobileMixin_onScreenChange)
    } else {
      this.mobileMixin_portraitQuery.addEventListener('change', this.mobileMixin_onMediaChange)
    }

    this.mobileMixin_onResize()
    window.addEventListener('resize', this.mobileMixin_onResize)
  },

  beforeDestroy: function () {
    window.removeEventListener('resize', this.mobileMixin_onResize)

    if (window.screen.orientation) {
      window.screen.orientation.removeEventListener('change', this.mobileMixin_onScreenChange)
    } else {
      this.mobileMixin_portraitQuery.removeEventListener('change', this.mobileMixin_onMediaChange)
    }
  },

  methods: {
    mobileMixin_onMediaChange() {
      this.mobileMixin_deviceOrientation = this.mobileMixin_portraitQuery.matches
        ? 'portrait'
        : 'landscape'
      console.debug(`[mobileMixin]: MediaOrientation: ${this.mobileMixin_deviceOrientation}.`)

      this.mobileMixin_onResize()
    },

    mobileMixin_onScreenChange(event) {
      const type = event.target.type // document's current orientation type
      const angle = event.target.angle // document's current orientation angle
      console.debug(`[mobileMixin]: ScreenOrientation: ${type} @ ${angle} degrees.`)

      this.mobileMixin_deviceOrientation = type.startsWith('portrait') ? 'portrait' : 'landscape'
      this.mobileMixin_onResize()
    },

    mobileMixin_onResize() {
      // this.mobileMixin_width = window.innerWidth // includes scrollbars
      // this.mobileMixin_height = window.innerHeight // includes scrollbars
      this.mobileMixin_width = document.documentElement.clientWidth
      this.mobileMixin_height = document.documentElement.clientHeight

      // console.debug(`[mobileMixin]: Resize change: ${this.mobileMixin_width} x ${this.mobileMixin_height}.`)
    }
  }
}
